import { Row } from '@tanstack/react-table';
import { SelectFilterValue } from '@components/primitives/dataGrid/components/filters/SelectFilter';

const selectFilter = <TData extends object>(row: Row<TData>, columnId: string, value: SelectFilterValue) => {
    const rowValue = row.getValue(columnId) as string;

    if (!value) {
        return true;
    }

    return value.includes(rowValue);
};

export default selectFilter;
